import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eef1577"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-container-light" }
const _hoisted_2 = { class: "register" }
const _hoisted_3 = { class: "register-body" }
const _hoisted_4 = { class: "highlight" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label label-color-light" }, "Subject*", -1))
const _hoisted_6 = { class: "highlight" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label label-color-light" }, "Message*", -1))
const _hoisted_8 = { class: "grid-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label label-color-light" }, "Name*", -1))
const _hoisted_10 = { class: "grid-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label label-color-light" }, "Email*", -1))
const _hoisted_12 = { class: "grid-wrapper policy-grid-wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "policy-label label-color-light" }, null, -1))
const _hoisted_14 = { class: "policy-content form-group form-check mt-2 mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label label-color-light",
  for: "exampleCheck1"
}, [
  /*#__PURE__*/_createTextVNode(" I accept the "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://presentaid.com/en/data-protection"
  }, "data privacy policy"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "http://presentaid.com/wp-content/uploads/2022/03/bkt-solutions-AGB-EULA.pdf"
  }, " GTC ")
], -1))
const _hoisted_16 = { class: "submit-container-light" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Subject*",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event))
          }, null, 512), [
            [_vModelText, _ctx.subject]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("textarea", {
            type: "text",
            class: "form-control",
            placeholder: "Message*",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event))
          }, null, 512), [
            [_vModelText, _ctx.message]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(_ctx.validationResult.isNameFilled ? 'form-control' : 'form-control is-invalid'),
            placeholder: "Name*",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerForm.name) = $event))
          }, null, 2), [
            [_vModelText, _ctx.registerForm.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(_ctx.validationResult.isEmailFilled ? 'form-control' : 'form-control is-invalid'),
            placeholder: "Email*",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerForm.email) = $event))
          }, null, 2), [
            [_vModelText, _ctx.registerForm.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: _normalizeClass(_ctx.validationResult.isTermsFilled ? 'form-check-input' : 'form-check-input is-invalid'),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terms) = $event)),
              id: "exampleCheck1"
            }, null, 2), [
              [_vModelCheckbox, _ctx.terms]
            ]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "submit-btn btn btn-primary",
            disabled: _ctx.isFormDisabled,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
          }, "Start Free Trial", 8, _hoisted_17)
        ])
      ])
    ])
  ]))
}